import React, { useState, useEffect } from "react";
import "./NavigationBar.css";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-scroll";
import { Brightness7, Brightness4 } from "@material-ui/icons";
import { navLinks } from "../../config.js";

function NavigationBar({ updateAppDarkMode }) {
    const [dark_mode, setDarkMode] = useState(getInitialMode());
    // save the dark_mode to your local storage and update App's component dark_mode variable
    useEffect(() => {
        localStorage.setItem("dark_mode", JSON.stringify(dark_mode));
        updateAppDarkMode(dark_mode);
        // eslint-disable-next-line
    }, [dark_mode]);

    // initialize dark mode
    function getInitialMode() {
        const isReturningUser = "dark_mode" in localStorage;
        // get user mode preference
        if (isReturningUser === true) {
            const savedMode = JSON.parse(localStorage.getItem("dark_mode"));
            return savedMode;
        } else return true;
    }

    // create our navigation items
    const nav_items = navLinks.map((nav_item, index) => {
        return (
            <Nav.Item key={index} className={nav_item.nav_item_class_name}>
                <Link
                    className={nav_item.link_class_name}
                    to={nav_item.to}
                    smooth={nav_item.smooth}
                    offset={nav_item.offset}
                    duration={nav_item.duration}
                >
                    {nav_item.text}
                </Link>
            </Nav.Item>
        );
    });

    return (
        <Navbar id="NavigationBar" className={dark_mode ? "dark_mode_nav" : "light_mode_nav"}>
            <Nav className="nav_links">
                {nav_items}
                <div
                    className="dark_mode_icon"
                    onClick={() => setDarkMode((prevMode) => !prevMode)}
                >
                    {dark_mode ? <Brightness7 /> : <Brightness4 />}
                </div>
            </Nav>
        </Navbar>
    );
}

export default NavigationBar;
